import {apiCall as apiCallInternal} from '@shared-frontend/api';
import {setSession} from '@shared-frontend/lib/session_store';

export const apiCall: typeof apiCallInternal = async (api, path, req, options) =>
  apiCallInternal(api, path, req, options, () => {
    setSession(undefined);
  });
